module.exports = "./images/00_shopvise.jpg";